import { useParams } from '@reach/router';

const useSelectedPatientId = (): string | undefined => {
  const params = useParams();
  return params?.patientId;
};

export default useSelectedPatientId;
